import Text from '../../graphics/Text';
import DraggablePreset from './DraggablePreset';
import { getCenterX, getCenterY } from '../../utils/CoordinateCalculator';

const MAX_FADE_DURATION = 1;

/**
 * This corresponds to our legacy fade in/out text
 */
export default class Zoom extends DraggablePreset {
  constructor(app) {
    super(app);
    this.titleText = new Text(app);

    this.container.addChild(this.titleText);
  }

  update(model) {
    super.update(model);

    const fadeDuration = Math.min(MAX_FADE_DURATION, this.duration / 2);

    // update content and size
    this.titleText.text = model.text;
    this.titleText.updateStyle(model);

    this.setDraggableRoot(
      this.titleText.innerControls.height,
      this.titleText.innerControls.width
    );

    // set starting values
    this.titleText.innerControls.x = getCenterX(
      this.titleText.innerControls,
      this.root
    );
    this.titleText.innerControls.y = getCenterY(
      this.titleText.innerControls,
      this.root
    );
    this.titleText.alpha = 0;
    this.titleText.pivot.x = this.titleText.innerControls.width / 2;
    this.titleText.pivot.y = this.titleText.innerControls.height / 2;
    this.titleText.innerControls.x += this.titleText.pivot.x;
    this.titleText.innerControls.y += this.titleText.pivot.y;

    // Build our animations
    this.animate(this.titleText)
      .to({
        alpha: this.primaryColor.getAlpha(),
        duration: fadeDuration,
      })
      .reverseOut();

    this.titleText.scale.x = 0.8;
    this.titleText.scale.y = 0.8;
    this.animate(this.titleText.scale).to({
      x: 1,
      y: 1,
      duration: this.duration,
    });
  }
}
